import request from "@/utils/request";
export function fetchList(data) {
  return request({
    url: "/whg-park/api/report/orderDailyReport",
    method: "post",
    data: data
  });
}